import { InventorySuppliersBus } from "../models/InventorySuppliersBus";
import { OrderDetailsBus } from "../models/OrderDetailsBus";
import { CommonFunctions } from "../static/common-functions";
import { InventoryService } from "../services/inventory.service";

export class PartSuppliers
{
    constructor(svc_inv: InventoryService) {

    }
    svc_inv: InventoryService;
    data: InventorySuppliersBus[];
    isActive: boolean = false;
    height: number = 0;
    show(dataItem: OrderDetailsBus) {
        this.svc_inv.getInventorySuppliers(dataItem.inventoryId).subscribe((data: InventorySuppliersBus[]) => {
            if (CommonFunctions.hasArrayValue(data)) {
                if (data.length > 20) {
                    this.height = 600;
                }
                else {
                    this.height = 0;
                }
            }
            this.data = data;
            this.isActive = true;
        });
    }
    close() {
        this.isActive = false;
    }
}
